import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type IfspPermissionType = {
  hasClientEditPermission: boolean;
  hasIfspEditPermissionAfterLock: boolean;
  hasIfspDeletePermissionAfterLock: boolean;
  hasUploadToTBRPermission: boolean;
  hasAdminAmendmentAddPermission: boolean;
  hasAdminAmendmentEditPermission: boolean;
  hasAdminAmendmentDeletePermission: boolean;
};

const initialState: IfspPermissionType = {
  hasClientEditPermission: false,
  hasIfspEditPermissionAfterLock: false,
  hasIfspDeletePermissionAfterLock: false,
  hasUploadToTBRPermission: false,
  hasAdminAmendmentAddPermission: false,
  hasAdminAmendmentEditPermission: false,
  hasAdminAmendmentDeletePermission: false,
};

const ifspPermissionSlice = createSlice({
  name: 'ifspPermission',
  initialState,
  reducers: {
    updateIfspPermission: (
      state,
      action: PayloadAction<IfspPermissionType>,
    ) => {
      state.hasClientEditPermission = action.payload.hasClientEditPermission;
      state.hasIfspEditPermissionAfterLock =
        action.payload.hasIfspEditPermissionAfterLock;
      state.hasIfspDeletePermissionAfterLock =
        action.payload.hasIfspDeletePermissionAfterLock;
      state.hasUploadToTBRPermission = action.payload.hasUploadToTBRPermission;
      state.hasAdminAmendmentAddPermission =
        action.payload.hasAdminAmendmentAddPermission;
      state.hasAdminAmendmentEditPermission =
        action.payload.hasAdminAmendmentEditPermission;
      state.hasAdminAmendmentDeletePermission =
        action.payload.hasAdminAmendmentDeletePermission;
    },
    resetIfspPermission: (state) => {
      state.hasClientEditPermission = initialState.hasClientEditPermission;
      state.hasIfspEditPermissionAfterLock =
        initialState.hasIfspEditPermissionAfterLock;
      state.hasIfspDeletePermissionAfterLock =
        initialState.hasIfspDeletePermissionAfterLock;
      state.hasUploadToTBRPermission = initialState.hasUploadToTBRPermission;
      state.hasAdminAmendmentAddPermission =
        initialState.hasAdminAmendmentAddPermission;
      state.hasAdminAmendmentEditPermission =
        initialState.hasAdminAmendmentEditPermission;
      state.hasAdminAmendmentDeletePermission =
        initialState.hasAdminAmendmentDeletePermission;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_REDUX_APP_STATES', () => initialState);
  },
});

export const { updateIfspPermission, resetIfspPermission } =
  ifspPermissionSlice.actions;
export default ifspPermissionSlice.reducer;
